module.exports = __webpack_public_path__ + "static/media/2019.eacfdda1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about/2019.svg
// module id = 610
// module chunks = 0